import React from 'react';
import './BannerZx.scss';
class BannerZx extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      bannerImages: [
        { imgPath: require("img/CompanyProfilebg.png"), imgHDPath: `${require("img/CompanyProfilebg.png")} 1x,${require("img/CompanyProfilebg@2x.png")} 2x,${require("img/CompanyProfilebg@3x.png")} 3x`, attachURL: "/" },
      ]
    }
  }
  componentDidMount() {
    // setTimeout(() => {
    //     this.props.transferHeight(this.refs.banner.getBoundingClientRect().height)
    //     console.log(this.refs.banner.getBoundingClientRect().height)
    // }, 0);
  }
  render() {
    return (
      <div className='BannerZx' ref="banner">
        <div className="BannerZx-body">
          <section className="swiper-container" >
            <div className="swiper-wrapper">
              {
                this.state.bannerImages.map((item, index) =>
                  item.attachURL && item.attachURL !== '/' ?
                    <a className="swiper-slide"
                      key={index}
                      href={item.attachURL}>
                      <img src={item.imgPath} alt="" srcSet={item.imgHDPath} width="100%" height="100%" />
                    </a>
                    :
                    <img key={index} src={item.imgPath} alt="" srcSet={item.imgHDPath} width="100%" height="100%" />
                )
              }
            </div>
            <div className="swiper-pagination"></div>
            <h5>青云万里 矩步方行</h5>
            <p>—— 创新 · 服务 · 共享 ——</p>
          </section>
        </div>
      </div>
    );
  }
}

export default BannerZx;
